import React, { useEffect, useState } from "react";
import { LoadPanel } from "devextreme-react";
import { ToastDisplayer } from "../../../../components/toastDisplay/ToastDisplayer";
import {
  createDepartment,
  deleteDepartment,
  getDepartments,
  updateDepartment,
} from "../../../../api/departmentApi";
import "./DepartmentTab.scss";
import { confirm } from "devextreme/ui/dialog";
export default function DepartmentTab() {
  const [loading, setLoading] = useState(false);
  const [departmentList, setDepartmentList] = useState([]);
  const [departmentInput, setDepartmentInput] = useState("");

  // Edit mode state
  const [editingId, setEditingId] = useState(null);
  const [editingValue, setEditingValue] = useState("");

  // ── FETCH all Departments ──────────────────────────────────────────────────
  const fetchDepartments = async () => {
    try {
      setLoading(true);

      const res = await getDepartments();

      if (res.success) {
        setDepartmentList(res.data.data || []);
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to fetch departments.",
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDepartments();
  }, []);

  // ── ADD Department ──────────────────────────────────────────────────────────
  const handleAddDepartment = async () => {
  if (!departmentInput.trim()) {
    ToastDisplayer("error", "Please enter a department name.");
    return;
  }

  try {
    setLoading(true);

    const res = await createDepartment({
      departmentname: departmentInput,
    });

    if (res.success) {
      ToastDisplayer("success", "Department added successfully!");
      setDepartmentInput("");
      fetchDepartments();
    } else {
      ToastDisplayer(
        "error",
        res.message || "Failed to add department."
      );
    }

  } catch (error) {
    ToastDisplayer(
      "error",
      error?.response?.data?.error ||
      error?.response?.data?.message ||
      "Failed to add department."
    );
  } finally {
    setLoading(false);
  }
};

  // ── START editing a row ─────────────────────────────────────────────────
  const handleEditClick = (item) => {
    setEditingId(item.transid);
    setEditingValue(item.departmentname);
  };

  // ── SAVE edited Department ──────────────────────────────────────────────────
  const handleEditSave = async (id) => {
    if (!editingValue.trim()) {
      ToastDisplayer("error", "Department name cannot be empty.");
      return;
    }

    try {
      setLoading(true);

      const res = await updateDepartment(id, {
        departmentname: editingValue,
      });

      if (res.success) {
        ToastDisplayer("success", "Department updated successfully!");
        setEditingId(null);
        setEditingValue("");
        fetchDepartments();
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Failed to update department.",
      );
    } finally {
      setLoading(false);
    }
  };
  // ── CANCEL editing ──────────────────────────────────────────────────────
  const handleEditCancel = () => {
    setEditingId(null);
    setEditingValue("");
  };

  // ── DELETE Department ───────────────────────────────────────────────────────
  const handleDelete = async (id) => {
    confirm("Are you sure you want to delete this record?").then(
      async (result) => {
        if (!result) return;

        try {
          setLoading(true);

          const res = await deleteDepartment(id);

          if (res.success) {
            ToastDisplayer("success", "Department deleted successfully!");
            fetchDepartments();
          }
        } catch (error) {
          ToastDisplayer(
            "error",
            error?.response?.data?.message || "Failed to delete department.",
          );
        } finally {
          setLoading(false);
        }
      },
    );
  };

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="depTabSec" >
        {/* ── Categories-style collapsible section ── */}
        <div className="depTabCard">
          <div className="depCardHead">
            <span className="depCardTitle">Manage Department</span>
          </div>

          {/* Input row — same layout as Category Name input */}
          <div className="depCardBody" >
            <div className="catInputRow">
              <div className="catInputWrap">
                <label className="catLabel">
                  Department Name <span className="required">*</span>
                </label>
                <input
                  className="catTextBox"
                  placeholder="Enter Department Name"
                  value={departmentInput}
                  onChange={(e) => setDepartmentInput(e.target.value)}
                  onKeyDown={(e) => e.key === "Enter" && handleAddDepartment()}
                />
              </div>
              <button className="catAddBtn" onClick={handleAddDepartment}>
                Add Department
              </button>
            </div>

            {/* ── Status list table ── */}
            <div className="catListWrap" style={{ height: "calc(100vh - 430px)" ,overflow:"auto"}}>
              <div className="catListHeader">
                <span>Department Name</span>
              </div>

              {departmentList.length === 0 && !loading && (
                <div className="catEmptyMsg">No Department found.</div>
              )}

              {departmentList.map((item) => (
                <div className="catListRow" key={item.transid}>
                  {editingId === item.transid ? (
                    <div className="catEditRow">
                      <input
                        className="catTextBox"
                        value={editingValue}
                        onChange={(e) => setEditingValue(e.target.value)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") handleEditSave(item.transid);
                          if (e.key === "Escape") handleEditCancel();
                        }}
                        autoFocus
                      />
                      <button
                        className="catSaveBtn"
                        onClick={() => handleEditSave(item.transid)}
                      >
                        ✓
                      </button>
                      <button
                        className="catCancelBtn"
                        onClick={handleEditCancel}
                      >
                        ✕
                      </button>
                    </div>
                  ) : (
                    <>
                      <span className="catRowText">{item.departmentname}</span>
                      <div className="catRowActions">
                        <button
                          className="catIconBtn editIcon"
                          title="Edit"
                          onClick={() => handleEditClick(item)}
                        >
                          <i className="ri-pencil-line" />
                        </button>
                        <button
                          className="catIconBtn deleteIcon"
                          title="Delete"
                          onClick={() => handleDelete(item.transid)}
                        >
                          <i className="ri-delete-bin-line" />
                        </button>
                      </div>
                    </>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
